import { render, staticRenderFns } from "./MultiImageInputSelectedImageContainer.vue?vue&type=template&id=21b8cd12&scoped=true"
import script from "./MultiImageInputSelectedImageContainer.vue?vue&type=script&lang=ts"
export * from "./MultiImageInputSelectedImageContainer.vue?vue&type=script&lang=ts"
import style0 from "./MultiImageInputSelectedImageContainer.vue?vue&type=style&index=0&id=21b8cd12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b8cd12",
  null
  
)

export default component.exports